import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';

import { GET_BENEFIT_GROUPS, GET_BENEFIT_GROUPS_SUCCESS, GET_BENEFIT_GROUPS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBenefitGroups({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitGroups`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFIT_GROUPS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFIT_GROUPS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_GROUPS_ERROR, payload: error });
  }
}

export function* watchGetBenefitGroup() {
  yield takeEvery(GET_BENEFIT_GROUPS, getBenefitGroups);
}

function* getBenefitGroupSaga() {
  yield all([fork(watchGetBenefitGroup)]);
}

export default getBenefitGroupSaga;
